// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1I8d5","detailsBorder":"styles_detailsBorder__2kx2t"};